export const iconFontAwesomeSecurityMarsAndVenusBurst = (
	<i className="fa-solid fa-mars-and-venus-burst"></i>
);
